/* XORIVAA theme scripts. Vanilla JS, no dependencies. Uses event delegation so it keeps working
   when sections are re-rendered in the Shopify theme editor. */
(function () {
  'use strict';
  var X = window.XV || { routes: { root: '/', cart: '/cart', cart_add: '/cart/add', predictive: '/search/suggest' }, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function load(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function save(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(text, href, linkText) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = text;
    if (href) { var a = document.createElement('a'); a.href = href; a.textContent = linkText; t.appendChild(a); }
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }

  /* ---------- drawers and search panel ---------- */
  function closeAll() {
    $$('.drawer.on, .search.on').forEach(function (el) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); });
    var sc = $('[data-scrim]'); if (sc) sc.classList.remove('on');
    document.body.classList.remove('no-scroll');
  }
  function openEl(sel) {
    var el = $(sel); if (!el) return;
    closeAll();
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    var sc = $('[data-scrim]'); if (sc) sc.classList.add('on');
    document.body.classList.add('no-scroll');
    var input = el.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 150);
  }

  /* ---------- cart ---------- */
  function refreshCount() {
    fetch(X.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count || ''; el.setAttribute('data-n', c.item_count); });
      }).catch(function () {});
  }
  function trackAdd() {
    try { if (window.fbq) window.fbq('track', 'AddToCart'); if (window.gtag) window.gtag('event', 'add_to_cart'); } catch (e) {}
  }
  function addToCart(formData, btn) {
    if (btn) btn.disabled = true;
    return fetch(X.routes.cart_add + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || X.strings.error); return; }
        toast(X.strings.added, X.routes.cart, X.strings.view_cart);
        refreshCount(); trackAdd();
      })
      .catch(function () { toast(X.strings.error); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- gallery ---------- */
  function showMedia(sec, id) {
    $$('[data-slide]', sec).forEach(function (s) { s.hidden = String(s.getAttribute('data-media-id')) !== String(id); });
    $$('[data-thumb]', sec).forEach(function (t) { t.classList.toggle('on', String(t.getAttribute('data-media-id')) === String(id)); });
  }
  var lbIndex = 0, lbSources = [];
  function openLightbox(sec, src) {
    var dlg = $('[data-lightbox]'); if (!dlg || !dlg.showModal) return;
    lbSources = $$('[data-zoom-src]', sec).map(function (e) { return e.getAttribute('data-zoom-src'); });
    lbIndex = Math.max(0, lbSources.indexOf(src));
    drawLightbox(); dlg.showModal();
  }
  function drawLightbox() {
    var body = $('[data-lightbox-body]'); if (!body) return;
    body.innerHTML = '';
    var img = document.createElement('img'); img.src = lbSources[lbIndex]; img.alt = '';
    body.appendChild(img);
  }

  /* ---------- variants ---------- */
  function selectedOptions(sec) {
    var out = [];
    $$('[data-option]:checked', sec).forEach(function (i) { out[parseInt(i.getAttribute('data-index'), 10)] = i.value; });
    return out;
  }
  function onOptionChange(sec) {
    var dataEl = $('[data-variants]', sec); if (!dataEl) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sel = selectedOptions(sec);
    $$('[data-option-label]', sec).forEach(function (l) { l.textContent = sel[parseInt(l.getAttribute('data-option-label'), 10)] || ''; });
    // Disable option values that cannot form an available variant with the current selection.
    $$('[data-option]', sec).forEach(function (input) {
      var idx = parseInt(input.getAttribute('data-index'), 10);
      var value = input.value;
      var possible = variants.some(function (v) {
        if (!v.available || v.options[idx] !== value) return false;
        return v.options.every(function (o, i) { return i === idx || !sel[i] || o === sel[i]; });
      });
      input.disabled = !possible;
      var label = sec.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('soldout', !possible);
    });
    var match = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0];
    var buy = $('[data-live="buy"]', sec), sticky = $('[data-live="sticky"]', sec);
    if (!match || !match.available) {
      $$('button[name="add"]', sec).forEach(function (b) { b.disabled = true; });
      return;
    }
    var idInput = $('[data-variant-id]', sec); if (idInput) idInput.value = match.id;
    var url = sec.getAttribute('data-product-url');
    try { history.replaceState({}, '', url + '?variant=' + match.id); } catch (e) {}
    if (match.media) showMedia(sec, match.media);
    fetch(url + '?variant=' + match.id + '&section_id=' + sec.getAttribute('data-section-id'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['price', 'inventory', 'buy', 'sticky'].forEach(function (k) {
          var n = $('[data-live="' + k + '"]', doc), o = $('[data-live="' + k + '"]', sec);
          if (n && o) o.innerHTML = n.innerHTML;
        });
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      }).catch(function () {});
  }

  /* ---------- wishlist ---------- */
  function wl() { return load('xv_wishlist') || []; }
  function syncWishlist() {
    var list = wl();
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length || ''; el.setAttribute('data-n', list.length); });
    $$('[data-wishlist]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function cardHtml(handle) {
    return fetch(X.routes.root + 'products/' + handle + '?section_id=product-card-ajax')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = $('#shopify-section-product-card-ajax', doc);
        return el ? el.innerHTML : '';
      }).catch(function () { return ''; });
  }
  function renderWishlistPage() {
    var grid = $('[data-wishlist-grid]'); if (!grid) return;
    var list = wl(), empty = $('[data-wishlist-empty]');
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    Promise.all(list.map(cardHtml)).then(function (parts) { grid.innerHTML = parts.join(''); syncWishlist(); });
  }
  function renderRecentlyViewed() {
    var sec = $('[data-recently-viewed]'); if (!sec) return;
    var current = sec.getAttribute('data-current'), limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    var list = (load('xv_recent') || []).filter(function (h) { return h !== current; }).slice(0, limit);
    if (!list.length) return;
    Promise.all(list.map(cardHtml)).then(function (parts) {
      var grid = $('[data-recently-grid]', sec); grid.innerHTML = parts.join(''); sec.hidden = false; syncWishlist();
    });
  }
  function recordViewed() {
    var p = $('[data-product-handle]'); if (!p) return;
    var h = p.getAttribute('data-product-handle');
    var list = (load('xv_recent') || []).filter(function (x) { return x !== h; });
    list.unshift(h); save('xv_recent', list.slice(0, 12));
  }
  function loadRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url'); if (!url || el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var n = $('[data-recommendations]', doc);
        if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; syncWishlist(); }
      }).catch(function () {});
    });
  }

  /* ---------- predictive search ---------- */
  var searchTimer;
  function runSearch(input) {
    var q = input.value.trim(), box = $('[data-predictive-results]'), pop = $('[data-popular]');
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; if (pop) pop.hidden = false; return; }
    if (pop) pop.hidden = true;
    fetch(X.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = $('#shopify-section-predictive-search', doc);
        box.innerHTML = el ? el.innerHTML : '';
      }).catch(function () { box.innerHTML = ''; });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.mnav a, .pred a, [data-popular] a')) setTimeout(closeAll, 0);

    var openBtn = t.closest('[data-open]');
    if (openBtn) { openEl(openBtn.getAttribute('data-open')); return; }
    if (t.closest('[data-close]') || t.closest('[data-scrim]')) { closeAll(); return; }

    var dlgOpen = t.closest('[data-dialog-open]');
    if (dlgOpen) { var d = $(dlgOpen.getAttribute('data-dialog-open')); if (d && d.showModal) d.showModal(); return; }
    if (t.closest('[data-dialog-close]')) { var dd = t.closest('dialog'); if (dd) dd.close(); return; }
    if (t.tagName === 'DIALOG') { t.close(); return; }

    if (t.closest('[data-lightbox-close]')) { $('[data-lightbox]').close(); return; }
    var step = t.closest('[data-lightbox-step]');
    if (step) { lbIndex = (lbIndex + parseInt(step.getAttribute('data-lightbox-step'), 10) + lbSources.length) % lbSources.length; drawLightbox(); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-product-section]'), thumb.getAttribute('data-media-id')); return; }
    var zoom = t.closest('[data-zoom-src]');
    if (zoom) { openLightbox(zoom.closest('[data-product-section]'), zoom.getAttribute('data-zoom-src')); return; }

    var qtyBtn = t.closest('[data-qty-step]');
    if (qtyBtn) {
      var input = $('input', qtyBtn.closest('[data-qty]'));
      var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.getAttribute('data-qty-step'), 10));
      input.value = next;
      if (input.hasAttribute('data-cart-qty')) { var f = input.form; clearTimeout(input._t); input._t = setTimeout(function () { var u = $('[data-cart-update]', f); if (u) u.click(); }, 600); }
      return;
    }

    var wish = t.closest('[data-wishlist]');
    if (wish) {
      var h = wish.getAttribute('data-handle'), list = wl(), i = list.indexOf(h);
      if (i > -1) { list.splice(i, 1); toast(X.strings.wishlist_removed); } else { list.push(h); toast(X.strings.wishlist_added); }
      save('xv_wishlist', list); syncWishlist();
      if ($('[data-wishlist-grid]') && i > -1) { var card = wish.closest('.card'); if (card) card.remove(); if (!wl().length) renderWishlistPage(); }
      return;
    }

    var qa = t.closest('[data-quick-add]');
    if (qa) { var fd = new FormData(); fd.append('id', qa.getAttribute('data-variant')); fd.append('quantity', '1'); addToCart(fd, qa); return; }

    var sc = t.closest('[data-scroll]');
    if (sc) { var car = $(sc.getAttribute('data-scroll')); if (car) car.scrollBy({ left: parseInt(sc.getAttribute('data-dir'), 10) * car.clientWidth * 0.8, behavior: 'smooth' }); return; }
    var st = t.closest('[data-scroll-to]');
    if (st) { var tgt = $(st.getAttribute('data-scroll-to')); if (tgt) tgt.scrollIntoView({ behavior: 'smooth' }); return; }

    var rec = t.closest('[data-toggle-recover]');
    if (rec) { e.preventDefault(); var r = $('#recover'), l = $('#login'); if (r && l) { var show = r.hidden; r.hidden = !show; l.hidden = show; } return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-zoom-src]')) { e.preventDefault(); e.target.click(); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    var sec = t.closest && t.closest('[data-product-section]');
    if (sec && t.matches('[data-option]')) { onOptionChange(sec); return; }
    if (t.matches('[data-autosubmit]') && t.form) { if (t.form.requestSubmit) t.form.requestSubmit(); else t.form.submit(); return; }
    if (t.closest('[data-facet-form]') && t.matches('input[type="checkbox"]')) { /* applied with the Apply button */ }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-search-input]')) { clearTimeout(searchTimer); var inp = e.target; searchTimer = setTimeout(function () { runSearch(inp); }, 250); }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-product-form]')) {
      e.preventDefault();
      var btn = $('button[name="add"]', f);
      if (btn && btn.disabled) return;
      addToCart(new FormData(f), btn);
    }
  });

  document.addEventListener('mousemove', function (e) {
    var m = e.target.closest && e.target.closest('.main-i'); if (!m) return;
    var img = $('img', m); if (!img) return;
    var r = m.getBoundingClientRect();
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  });

  function init() {
    syncWishlist(); recordViewed(); renderRecentlyViewed(); renderWishlistPage(); loadRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { syncWishlist(); loadRecommendations(); renderRecentlyViewed(); renderWishlistPage(); });
})();
